import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerRoutingModule } from '../../../app/customer/customer-routing.module';
import { SharedModule } from '../../shared.module';
import { NgChartsModule } from 'ng2-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import {
  CalculatorCountryPickerComponent,
} from './calculator-components/calculator-country-picker/calculator-country-picker.component';
import { CalculatorComponent } from './calculator.component';
import {
  CalculatorTariffGroupSelectorComponent,
} from './calculator-components/calculator-tariff-group-selector/calculator-tariff-group-selector.component';
import {
  CalculatorSupplierSelectorComponent,
} from './calculator-components/calculator-supplier-selector/calculator-supplier-selector.component';
import {
  CalculatorConsumptionInputComponent,
} from './calculator-components/calculator-consumption-input/calculator-consumption-input.component';
import { CalculatorMapComponent } from './calculator-components/calculator-map/calculator-map.component';
import { InfoIconComponent } from '../info-icon/info-icon.component';
import { TranslateStringArrayPipe } from '../../pipes/translate-string-array.pipe';
import { ConsumptionInputComponent } from './consumption-input-dialog/consumption-input.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  CalculatorSiteDataInputsComponent,
} from './calculator-components/calculator-site-data-inputs/calculator-site-data-inputs.component';
import {
  CalculatorPlantDataComponent,
} from './calculator-components/calculator-plant-data/calculator-plant-data.component';
import { UserHasRolePipe } from '../../pipes/user-has-role.pipe';
import { ResultTitleComponent } from '../solar-calculation-result/result-title/result-title.component';
import {
  SimpleCalculatorMapComponent,
} from './calculator-components/simple-calculator-map/simple-calculator-map.component';
import { SimpleCalculatorComponent } from './calculator-components/simple-calculator/simple-calculator.component';
import { OrientationPointerComponent } from './calculator-components/orientation-pointer/orientation-pointer.component';
import {
  SimpleDrawCalculatorMapComponent,
} from './calculator-components/simple-draw-calculator-map/simple-draw-calculator-map.component';


@NgModule({
  declarations: [
    CalculatorTariffGroupSelectorComponent,
    CalculatorSupplierSelectorComponent,
    CalculatorCountryPickerComponent,
    CalculatorConsumptionInputComponent,
    CalculatorMapComponent,
    ConsumptionInputComponent,
    CalculatorComponent,
    CalculatorSiteDataInputsComponent,
    CalculatorPlantDataComponent,
    SimpleCalculatorMapComponent,
    SimpleDrawCalculatorMapComponent,
    SimpleCalculatorComponent,
    OrientationPointerComponent,
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    SharedModule,
    TranslocoModule,
    NgChartsModule,
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    InfoIconComponent,
    TranslateStringArrayPipe,
    GoogleMapsModule,
    UserHasRolePipe,
    ResultTitleComponent,
  ],
  exports: [
    CalculatorComponent,
    SimpleCalculatorComponent,
    SimpleCalculatorMapComponent,
    SimpleDrawCalculatorMapComponent,
    OrientationPointerComponent,
  ],
})
export class CalculatorModule { }
